@if (dialog.active()) {
  <div class="pathways-modal-backdrop" (click)="onBackdropClick()">
    <div
      class="pathways-modal-card staticrypt-passphrase-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="staticrypt-passphrase-title"
      (click)="$event.stopPropagation()"
    >
      <div class="pathways-title-accent-block">
        <h3 id="staticrypt-passphrase-title" class="pathways-modal-title">
          {{ titleText() }}
        </h3>
        <div class="qprime-accent-bar" aria-hidden="true"></div>
      </div>
      <p class="pathways-modal-message">
        {{ messageText() }}
      </p>
      <label class="staticrypt-field">
        <span>Passphrase</span>
        <input
          type="password"
          autocomplete="new-password"
          [attr.maxlength]="maxLen"
          [ngModel]="passphrase()"
          (ngModelChange)="passphrase.set($event); error.set('')"
        />
      </label>
      <label class="staticrypt-field">
        <span>Confirm passphrase</span>
        <input
          type="password"
          autocomplete="new-password"
          [attr.maxlength]="maxLen"
          [ngModel]="confirm()"
          (ngModelChange)="confirm.set($event); error.set('')"
        />
      </label>
      @if (error()) {
        <p class="staticrypt-error" role="alert">{{ error() }}</p>
      }
      <div class="pathways-modal-actions">
        <button type="button" class="pathways-btn-secondary" (click)="onCancel()">Cancel</button>
        <button type="button" class="pathways-btn-primary" (click)="onConfirm()">
          {{ confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
